import {observable} from 'mobx';
import {createInstance} from 'utils';

import {SeoLocaleKey} from './seo-locale-key';
import {SeoLocaleContent} from './seo-locale-content';

export class SeoLocale extends SeoLocaleKey {
    @observable id!: number;

    @observable initialContent: string = '';

    @observable motherContent?: SeoLocaleContent;

    @observable targetContent?: SeoLocaleContent;

    constructor(translation?: SeoLocale) {
        super(translation);
        if (translation) {
            this.id = translation.id;
            this.motherContent = createInstance(SeoLocaleContent, translation.motherContent);
            this.targetContent = createInstance(SeoLocaleContent, translation.targetContent);
            if (this.targetContent) {
                this.initialContent = this.targetContent.contentEdited;
            }
        }
    }
}